export default function Footer(){
    return (
        <footer className="footer bg-light">
            <div className="container-fluid d-flex flex-md-row flex-column justify-content-center align-items-center gap-1 container-p-x py-3">
                <div className="text-center">
                    <a href={'www.netikash.com'} target="_blank" className="footer-text fw-bold">Netikash</a> ©  {new Date().getFullYear()}
                </div>
            </div>
        </footer>
    );
}